module.exports = __webpack_public_path__ + "static/log-top10-2025-8adf495a2d49c7e24daa4395622ff93e.png";